const hasScrollbar = (element: HTMLElement) => {
  return element.scrollHeight > element.clientHeight || element.scrollWidth > element.clientWidth;
};

const hasScrollbarRecursive = (element: HTMLElement) => {
  if (hasScrollbar(element)) {
    return true;
  }
  const children = element.children;
  for (let i = 0; i < children.length; i++) {
    if (hasScrollbarRecursive(children[i] as HTMLElement)) {
      return true;
    }
  }
  return false;
};

export { hasScrollbar, hasScrollbarRecursive };
